import { cn } from '@/lib/utils/cn'
import type { RecordStatus } from '../api/records-api'
import { RECORD_STATUS_CONFIG } from '../lib/status-config'

export function RecordStatusBadge({ status }: { status: RecordStatus }) {
  const cfg = RECORD_STATUS_CONFIG[status] ?? RECORD_STATUS_CONFIG.draft
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', cfg.badgeClass)}>
      {cfg.label}
    </span>
  )
}
